/**
 * Flag keys, exactly as registered with the provider. Naming (R11 / TL-3955): lowercase
 * `<area>_<feature>` — Flagsmith lowercases names, and no dots or spaces keeps a key portable.
 *
 * Kept apart from `feature-flags.ts` so that naming a flag costs nothing to import. That module
 * pulls in the OpenFeature SDK and the Flagsmith provider and calls `OpenFeature.getClient()` at
 * module scope; somewhere like the router's route table only wants the string, and should not drag
 * the flag runtime into its bundle — or into the import graph of every spec that touches it.
 * `feature-flags.ts` re-exports this, so `FLAGS` can still be imported from either.
 */
export const FLAGS = {
  /** Placeholder for verifying the pipeline end to end; replace with the first real feature. */
  platformExample: 'platform_example_flag',
  /** Assignment groups (TL-4076): the group mode on the New Assignment page. */
  assignmentGroupEnabled: 'assignment_groups',
  /** TL-4093: gates the new Catalog nav entry and screens, per company. */
  courseCatalogAdminView: 'course_catalog_admin_view',
  /** AirMason Handbooks integration (TL-4342). Mirrors AirMasonHandbooksFeatureGate::FLAG in lms-service. */
  airmasonHandbooks: 'airmason_handbooks',
} as const;

export default FLAGS;
